import { countryImages } from '~/constants/countries';

import styles from './CountryOption.module.scss';

export function CountryOption({
  name,
  countryCode,
}: {
  name: string;
  countryCode: string;
}): JSX.Element {
  return (
    <div className={styles.countryOption}>
      <img
        className={styles.flag}
        src={(countryImages as Record<string, string>)[countryCode]}
        alt={`${name} flag`}
        width={30}
        height={20}
      />
      {name}
    </div>
  );
}
